/**
 * @packageDocumentation
 * @module HackerAPI.Event.Team.Member
 */
import { __extends } from "tslib";
import Base from "../../../base/base";
import { parseDate } from "../../../utils/utils";
/**
 * A container for data about a member of a team for an event
 * @class
 * @extends { HackerAPI.Base }
 */
var Member = /** @class */ (function (_super) {
    __extends(Member, _super);
    /**
     * Creates a new team member
     * @constructor
     * @param member
     */
    function Member(_a) {
        var id = _a.id, name = _a.name, institution = _a.institution, joined_at = _a.joined_at, joinedAt = _a.joinedAt;
        var _this = _super.call(this) || this;
        /**
         * The member's user id. Use this to get more info about them.
         * @type { number }
         */
        _this.id = id;
        /**
         * The member's name
         * @type { string }
         */
        _this.name = name;
        /**
         * The institution that they attend
         * @type { string }
         */
        _this.institution = institution;
        /**
         * When the member joined the team
         * @type { Date }
         */
        _this.joinedAt = parseDate(joined_at || joinedAt);
        return _this;
    }
    return Member;
}(Base));
export default Member;
//# sourceMappingURL=member.js.map